<template>
  <div class="quiz-form form">
    <div class="field">
      <label for="title" class="label">Título *</label>
      <div class="control">
        <input
          type="text"
          class="input"
          id="title"
          v-model="fData.title"
          :disabled="isDisabled || disabledFields.title"
        >
      </div>
    </div>
    <div class="field">
      <label for="description" class="label">Descrição</label>
      <div class="control">
        <input
          type="text"
          class="input"
          v-model="fData.description"
          id="shortdesc"
          maxlength="200"
          :disabled="isDisabled || disabledFields.description"
        >
        <div class="is-pulled-right">
          <char-count
            :countdown="200"
            :data-string="fData.description"
            suffix="caracteres restantes"
          />
        </div>
      </div>
    </div>
    <div class="field has-text-centered" style="clear: both">
      <button
        class="button is-primary is-large"
        @click="onSubmit(fData)"
        :class="{ 'is-loading': isLoading }"
        :disabled="isDisabled || $v.fData.$invalid"
      >
        {{ButtonLabel || "Cadastrar"}}
      </button>
    </div>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import FormMixin from './FormMixin'
import CharCount from '../CharCount'

export default {
  name: 'QuizForm',
  mixins: [FormMixin],
  components: { CharCount },
  data () {
    return {
      fData: {
        title: '',
        description: ''
      }
    }
  },
  validations: {
    fData: {
      title: {
        required
      },
      description: {
        maxLength: maxLength(200)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/QuizForm.vue